import { render, staticRenderFns } from "./MentionBox.vue?vue&type=template&id=84f545c4&scoped=true&"
import script from "./MentionBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./MentionBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MentionBox.vue?vue&type=style&index=0&id=84f545c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f545c4",
  null
  
)

export default component.exports